<script lang="ts" setup>
import type { GetProjectDetailsProjectResponse } from '@/api';
import { useTracking } from '@/utilities/tracking.ts';
import { getClientConfiguration } from '@/utilities/client-configuration.ts';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  project: GetProjectDetailsProjectResponse;
}>();

const { trackAction } = useTracking();
const staticMapUrl = ref<string>();

onMounted(() => {
  const googleMapsApiKey = getClientConfiguration().googleMapsApiKey;
  staticMapUrl.value = `https://maps.googleapis.com/maps/api/staticmap?center=${props.project.coordinates.latitude},${props.project.coordinates.longitude}&zoom=12&size=640x240&scale=2&markers=${props.project.coordinates.latitude},${props.project.coordinates.longitude}&map_id=13d35f2a07106723&key=${googleMapsApiKey}`;
});

function onClick() {
  void trackAction('project', props.project.id, 'mapClick');
}
</script>

<template>
  <section>
    <a :href="`https://www.google.com/maps/search/?api=1&query=${project.coordinates.latitude},${project.coordinates.longitude}`" class="block h-full" rel="noopener noreferrer" target="_blank" @click="onClick">
      <div class="aspect-[8/3] overflow-hidden rounded-xl lg:aspect-auto lg:h-full lg:min-h-72">
        <img v-if="staticMapUrl" :src="staticMapUrl" alt="Map" class="h-full w-full object-cover" />
      </div>
    </a>
  </section>
</template>

<style lang="css" scoped></style>
